// extracted by mini-css-extract-plugin
module.exports = {"drawCubesButton":"DrawFromBagButton_drawCubesButton__ZdYT8","drawCubesText":"DrawFromBagButton_drawCubesText__18iTc"};